import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";
import "./mobile/mobile.css";
import "./mobile/member-pages.css";
import "./mobile/record-pages.css";
import "./messaging.css";
import "./mobile/home.css";
import "./mobile/lobby.css";
import "./mobile/west-coast.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
